import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { endImpersonation } from '../api/endImpersonation.js';
import { startImpersonation } from '../api/startImpersonation.js';

/**
 * Both operations swap the user on the session behind the client's back. Everything
 * user-bound — currentUser, the impersonation banner, the sidebar's admin entry — hangs off
 * the one subscription set up here, so it has to be rebuilt afterwards. That is the whole
 * reason these two wrappers exist; do not call the operations directly.
 *
 * (The engine ships the same pair in @adornis/users/client/impersonation.js, but around its
 * own operations, whose permission model this app does not use — see api/startImpersonation.)
 */

/**
 * Continue as another account.
 *
 * @returns a display name for the account taken over
 */
export const impersonate = async (userID: string): Promise<string> => {
  const name = await startImpersonation(userID)();
  await subscribeCurrentUser();
  return name;
};

/** Hand the session back to the administrator who started the impersonation. */
export const stopImpersonating = async (): Promise<void> => {
  await endImpersonation()();
  await subscribeCurrentUser();
};
